<template>
  <div class="profile content-wrapper" v-if="user.data.firestore">
    <h1>Settings</h1>
    <div class="profile-grid">
      <div class="section">
        <h2 class="heading">Full Name</h2>
        <div class="input-container">
          <input class="input" id="name" type="text" v-model="user.data.firestore.name" placeholder="Please provide full name" />
        </div>
      </div>
      <div class="section">
        <h2 class="heading">Languages</h2>
        <span class="description">Select your native language</span>
        <div class="select-container select-container--no-label">
          <select id="language" v-model="user.data.firestore.languages">
            <option value="">None</option>
            <option v-for="language in languageList" :key="language.id" :value="language.id">{{ language.name }}</option>
          </select>
          <!-- prettier-ignore -->
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" fill="#999" /></svg>
        </div>
      </div>
      <div class="select-container select-container--no-label">
        <h2 class="heading">Word count and earnings</h2>
        <div v-if="isFetchingWordCount">Fetching word count and earnings, please wait..</div>
        <div v-else>
          <div v-if="userWordCount === null">No data found..</div>
          <div v-else>
            <table class="inline-table">
              <tr>
                <th>Month</th>
                <th>Words</th>
                <th>Fee</th>
              </tr>
              <tr v-for="item in userWordCount" v-bind:key="item.date">
                <td>{{ item.date }}</td>
                <td>{{ item.wordCount }}</td>
                <td>{{ currency }} {{ item.rate }}</td>
              </tr>
            </table>

            <span class="details">Your fee is calculated based on a rate/word of {{ currency }}{{ word }}.</span>
          </div>
        </div>
      </div>
    </div>
    <button class="button" @click="save">Save</button>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  data() {
    return {
      userWordCount: null,
      isFetchingWordCount: false,
    }
  },
  methods: {
    async save() {
      try {
        await firebase
          .firestore()
          .collection('users')
          .doc(this.user.data.uid)
          .set(this.user.data.firestore)
        this.$notify({
          text: 'Successfully saved profile',
          type: 'success',
        })
      } catch (error) {
        this.$notify({
          text: 'Failed to save profile',
          type: 'error',
        })
      }
    },
    async fetchWordCount() {
      this.isFetchingWordCount = true
      let url = new URL('https://europe-west1-freelance-ffddb.cloudfunctions.net/freelancer-word-count')
      url.searchParams.set('id', this.user.data.uid)
      url.searchParams.set('wordrate', this.user.data.firestore.rates.word)
      try {
        const { data } = await axios.get(url)
        this.userWordCount = data
        this.isFetchingWordCount = false
      } catch (error) {
        this.$notify({
          text: 'Failed to fetch word count and earnings',
          type: 'error',
        })
      }
    },
  },
  mounted: function() {
    this.fetchWordCount()
  },
  computed: {
    ...mapGetters(['languageList', 'user']),
    currency() {
      return this.user.data.firestore.rates.currency
    },
    word() {
      return this.user.data.firestore.rates.word
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';
@import '@/assets/shared-styles/input.scss';
@import '@/assets/shared-styles/inline-table.scss';
@import '@/assets/shared-styles/select.scss';

.profile {
  .input {
    min-width: 300px;
  }
  .heading {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
}
.section {
  display: flex;
  flex-direction: column;
}
.description {
  font-size: 0.875rem;
  margin-bottom: 1rem;
}
.profile-grid {
  display: grid;
  gap: 1.5rem;
}
// .table {
//   .table__row {
//     cursor: inherit;
//     &:hover {
//       background-color: inherit;
//     }
//   }
//   margin-bottom: 1em;
// }
</style>
